import { Gets } from './Gets';

export abstract class Caching extends Gets
{
	protected cacheUpdate(reqObj)
	{
		if (reqObj.getReq("id") === null) {
			throw this.getAuto().newException("Id attribute is mandatory");
		} else if (reqObj.getReq("data") === null) {
			throw this.getAuto().newException("Data attribute is mandatory");
		} else if (reqObj.getReq("meta") === null) {
			throw this.getAuto().newException("Meta attribute is mandatory");
		}
		var storeObj	= this.getService().getStores().getById(reqObj.getReq("id"), false);
		if (storeObj !== null) {
			storeObj.cacheUpdate(reqObj.getReq("data"), reqObj.getReq("meta"));
		}
	}
	protected cacheDelete(reqObj)
	{
		if (reqObj.getReq("id") === null) {
			throw this.getAuto().newException("Id attribute is mandatory");
		}
		var storeObj	= this.getService().getStores().getById(reqObj.getReq("id"), false);
		if (storeObj !== null) {
			storeObj.cacheDelete();
		}
	}
}